/*
* Aydin Cinar <cinar.aydinn@gmail.com>
* Mutations
*/

export const SET_ANSWERS = 'set-answers';
export const SET_SERVICES = 'set-services';
export const SET_PROGRESS = 'set-progress';
export const SET_QUESTIONS = 'set-questions';